import React from 'react'
import pechat from '../../../../Assets/Images/shutterstock_105434768_1-removebg-preview.png'
import qualityImg from '../../../../Assets/Images/download1.png'
// import "./Quality.css";

export default function Team() {
    return (
        <div className='quality'>
            <div className="container">
                <div className="quality-box">
                    <h3 className="quality-title">
                    Our Team
                     </h3>
                    <p className="quality-text">
                    “ Our Team is one of our greatest strengths which
 sets us apart from the competition.
 Our team consists of hardworking, 
dedicated , skilled & experienced people.
We at Be natural organics foods & cereals
 Put you First before everything else”.
                    </p>
                    <a href='#' className="quality-link">learn more</a>
                </div>
                <img src={qualityImg} alt="" className="quality-img" />
                <img src={pechat} alt="pechat" className="quality-icon" />
            </div>

        </div>
    )
}
